import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesPacks } from "../../constants";
import { CreatePackSlotBody } from "../useCreatePack/createPack.types";

export interface ReplacePackSlotsRequestBody {
  packId: string;
  slots: CreatePackSlotBody[];
}

export const requestReplacePackSlots = async ({
  packId,
  slots
}: ReplacePackSlotsRequestBody): Promise<void> => {
  return await instance.put(
    buildUrl(ApiRoutesPacks.Packs, packId, ApiRoutesPacks.PackSlots),
    { slots }
  );
};
